/** @format */

const template = `
<div class="current-organisation-role-share-editor-container form-group">
  <div ng-if="!$ctrl.hideButtons">
    <button
      type="button"
      class="btn btn-primary btn-naked btn-sm"
      ng-if="!$ctrl.showResetButton && !!$ctrl.save"
      ng-click="!$ctrl.saveOrganisationRoleShares()"
      ng-disabled="$ctrl.isRoleMissing() || $ctrl.isOrganisationMissing() || $ctrl.isRoleShareTotalInvalid()">
      <sis-icon icon="back"></sis-icon><span translate>SIS_COMPONENTS.BUTTON.SAVE</span>
    </button>
    <button
      type="button"
      class="btn btn-primary btn-naked btn-sm"
      ng-if="$ctrl.showResetButton"
      ng-click="!$ctrl.resetOrganisationRoleShares()">
      <sis-icon icon="back"></sis-icon><span translate>SIS_COMPONENTS.BUTTON.RESET</span>
    </button>
  </div>

  <sis-basic-grouping-panel
    heading="{{ $ctrl.getOrganisationsTranslationKey() | translate }}"
    guidance="{{$ctrl.isCoordinatingOrganisation() ?
                            'SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_EDITOR.COORDINATING_ORGANISATIONS_GUIDANCE' :
                            ''}}">
    <div class="row label-row" ng-if="$ctrl.getOrganisationRoleSharesByRoleUrn().length > 0">
      <label
        ng-class="{'col-8': !$ctrl.isCoordinatingOrganisation(), 'required': $ctrl.isResponsibleOrganisation(), 'col-4': $ctrl.isCoordinatingOrganisation()}"
        translate="SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_EDITOR.ORGANISATION"></label>
      <div class="col-4" ng-if="$ctrl.isCoordinatingOrganisation()">
        <label translate="SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_EDITOR.EDUCATIONAL_INSTITUTION"></label>
      </div>
      <div class="col-3 col-sm-2 col-md-3 second-label">
        <label class="required" translate="SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_EDITOR.ROLE_SHARE"></label>
      </div>
    </div>
    <ng-form name="$ctrl.currentOrganisationRoleShareForm" novalidate>
      <div class="row organisation-row" ng-repeat="organisationRoleShare in $ctrl.getOrganisationRoleSharesByRoleUrn()">
        <div ng-class="{ 'col-8': !$ctrl.isCoordinatingOrganisation(), 'col-4': $ctrl.isCoordinatingOrganisation()}">
          <search-organisation
            name="orgSearch"
            organisation="organisationRoleShare.organisation"
            organisation-service="$ctrl.organisationService"
            on-select="$ctrl.selectOrganisation(organisationRoleShare, orgObj)"
            disabled-organisation-ids="$ctrl.selectedOrganisationIds">
          </search-organisation>
        </div>

        <div class="col-4" ng-if="$ctrl.isCoordinatingOrganisation()">
          <sis-code-select-editor
            name="educationalInstitutionUrn"
            [codebook-urn]="'urn:code:educational-institution'"
            [selected-urn]="organisationRoleShare.educationalInstitutionUrn"
            (on-select-code)="$ctrl.setSelectedEducationalInstitutionUrn(organisationRoleShare, $event.selectedUrn)"
            [exclude-codes]="$ctrl.excludedEducationalInstitutions"></sis-code-select-editor>
        </div>

        <div class="col-3 col-sm-2 col-md-3">
          <percent-editor ng-model="organisationRoleShare.share" ng-change="$ctrl.changeOrganisationRoleShare()"></percent-editor>
        </div>

        <div class="col-1 button-col">
          <button
            type="button"
            class="btn btn-primary btn-naked btn-lg form-control btn-just-icon"
            title="{{::'SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.REMOVE' |translate}}"
            ng-click="$ctrl.removeOrganisationRoleShare(organisationRoleShare)"
            aria-label="{{::'SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.REMOVE' |translate}}">
            <sis-icon icon="delete"></sis-icon>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-12">
          <ul class="error-list" role="alert">
            <li ng-if="$ctrl.isResponsibleOrganisationMissing()" translate
              >SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.ORGANISATION_MISSING
            </li>
            <li ng-if="$ctrl.isOrganisationMissing()" translate>
              SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.ORGANISATION_MISSING
            </li>
            <li ng-if="$ctrl.isOrganisationAndEducationalInstitutionMissing()" translate>
              SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.ORGANISATION_AND_EDUCATIONAL_INSTITUTION_MISSING
            </li>
            <li ng-if="$ctrl.isOrganisationAndEducationalInstitutionDefined()" translate>
              SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.ONLY_ORGANISATION_OR_EDUCATIONAL_INSTITUTION
            </li>
            <li ng-if="$ctrl.isRoleShareTotalInvalid()" translate>
              SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.SUM_OF_SHARES_MUST_EQUAL_HUNDRED
            </li>
            <li ng-if="$ctrl.someRoleSharesAreNotPositive()" translate>
              SIS_COMPONENTS.ORGANISATION.ORGANISATION_ROLE_SHARE_VALIDITY_GROUP_EDITOR.SHARE_MUST_BE_OVER_ZERO
            </li>
          </ul>
        </div>
      </div>
    </ng-form>
  </sis-basic-grouping-panel>
  <button type="button" class="link-button" ng-click="$ctrl.addNewOrganisationRoleShare()" data-cy="add-organisation-role-share">
    <sis-icon icon="ring-plus"></sis-icon>{{ $ctrl.getAddTranslationKey() | translate}}
  </button>
</div>
`;
export default template;
